import React from "react";
import { AgreementPage } from "@/components";
import agreementsData from "@/assets/agreements/agreements.json";

/**
 * Privacy page component that displays the privacy policy.
 */
export default function PrivacyScreen() {
  return (
    <AgreementPage
      title="Privacy Policy"
      content={agreementsData.privacyPolicy}
    />
  );
}
